<template>
  <v-btn class="mx-0" @click="goBack">Volver</v-btn>
</template>

<script>
export default {
  data () {
    return {
    }
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
